import { createFileRoute, Navigate } from '@tanstack/react-router';
import { type ReactElement } from 'react';

import { agentConfigurationSearchSchema } from '@apps/web/components/automations/agent_configuration_search';
import { useSettingsGates } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/(main)/automations')({
    validateSearch: agentConfigurationSearchSchema,
    head: () => ({ meta: [{ title: 'Configurations | Phoebe' }] }),
    component: AgentConfigurationRoute,
});

function AgentConfigurationRoute(): ReactElement | null {
    const { isLoading, gates } = useSettingsGates();
    const search = Route.useSearch();

    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.agentV3) {
        return <Navigate to="/home" replace={true} />;
    }
    return (
        <Navigate
            to="/settings/configurations"
            search={search}
            replace={true}
        />
    );
}
